import { call, put, takeLatest } from 'redux-saga/effects';
import { CommissionShareOrder } from '@models/Commission';
import { CommissionApi, GetCommissionsParams } from '@apis/CommissionApi';
import { Pagination } from '@models/Pagination';
import { SagaPayload } from '@utils/typescript';
import { commissionSharesFetch, stateUpdate, StateUpdatePayload } from './action';

function* handleCommissionSharesFetch({ payload }: SagaPayload<GetCommissionsParams>) {
  const state: StateUpdatePayload = { loading: true, error: null };
  yield put(stateUpdate(state));

  try {
    const [commissionShares, pagination] = (yield call(CommissionApi.getAll, payload)) as [
      CommissionShareOrder[],
      Pagination,
    ];
    state.commissionShares = commissionShares;
    state.pagination = pagination;
    state.loading = false;
    yield put(stateUpdate(state));
  } catch (error: any) {
    state.loading = false;
    state.error = error?.message || 'Failed to load commission shares';
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(commissionSharesFetch, handleCommissionSharesFetch);
}
